export default "__VITE_ASSET__oEPz8whG__"